import { apiSlice } from "../api/apiSlice";
import io from "socket.io-client";
export const messagesApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getMessages: builder.query({
            query: (id) =>
                `/messages?conversationId=${id}&_sort=timestamp&_order=desc&_page=1&_limit=${process.env.REACT_APP_MESSAGES_PER_PAGE}`,
                transformResponse(apiResponse, meta) {
                    const totalCount = meta.response.headers.get("X-Total-Count");
                    console.log(totalCount);
                    return {
                        data: apiResponse,
                        totalCount,
                    };
                },
                async onCacheEntryAdded(
                arg,
                { updateCachedData, cacheDataLoaded, cacheEntryRemoved }
            ) {
                // create socket
                const socket = io("https://priyoserveryahoo.herokuapp.com", {
                    reconnectionDelay: 1000,
                    reconnection: true,
                    reconnectionAttemps: 10,
                    transports: ["websocket"],
                    agent: false,
                    upgrade: false,
                    rejectUnauthorized: false,
                });

                try {
                    await cacheDataLoaded;
                    socket.on("messages", (data) => {
                        // console.log(data);
                        updateCachedData((draft) => {
                            //    draft.data.push(data);
                            // console.log(JSON.parse(JSON.stringify(draft)));
                            
                            draft.data.push({
                                conversationId: data.data.conversationId,
                                message:data.data.message,
                                receiver: {
                                    email: data.data.receiver.email,
                                    password: data.data.receiver.password,
                                    name: data.data.receiver.name,
                                    id: data.data.receiver.id,
                                },
                                sender: {
                                    email: data.data.sender.email,
                                    password: data.data.sender.password,
                                    name: data.data.sender.name,
                                    id: data.data.sender.id,
                                },
                                timestamp: data.data.timestamp
                            });
                        });

                    });
                } catch (err) { }

                await cacheEntryRemoved;
                socket.close();
            },

        }),
        getMoreMessages: builder.query({
            query: ({ id, page }) =>
            `/messages?conversationId=${id}&_sort=timestamp&_order=desc&_page=${page}&_limit=${process.env.REACT_APP_MESSAGES_PER_PAGE}`,
            async onQueryStarted({ id }, { queryFulfilled, dispatch }) {
                try {
                    const messages = await queryFulfilled;
                    if (messages?.data?.length > 0) {
                        // update conversation cache pessimistically start
                        dispatch(
                            apiSlice.util.updateQueryData(
                                "getMessages",
                                id,
                                (draft) => {
                                    return {
                                        data: [
                                            ...draft.data,
                                            ...messages.data,
                                        ],
                                        totalCount: Number(draft.totalCount),
                                    };
                                }
                            )
                        );
                        // update messages cache pessimistically end
                    }
                } catch (err) { }
            },
        }),
        addMessage: builder.mutation({
            query: (data) => ({
                url: "/messages",
                method: "POST",
                body: data,
            }),
        }),
    }),
});

export const { useGetMessagesQuery, useAddMessageMutation, useGetMoreMessagesQuery } = messagesApi;
